// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#005aaa","primaryColorLight":"#0567bf","primaryColorLighter":"#238eed","primaryColorLightest":"#6eb2ef"};